const BACKEND_URL = 'http://127.0.0.1:4000';


export default BACKEND_URL;
